import { createSlice } from "@reduxjs/toolkit";
import { userLogin } from "../thunk/auth.thunk";

const defaultAuthState = {
  userDetails: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: "authSlice",
  initialState: defaultAuthState,
  reducers: {
    setUserInfo: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload,
      },
    }),
  },
  extraReducers: (builder) => {
    /**
     * Uncomment this and add login thunk to save data from thunk response. (change userLogin.fulfilled to LOGIN_THUNK_NAME:fulfilled)
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        return {
          ...state,
          userInfo: { user, wallet },
          isLoggedIn: true
        }
      })
    */
  },
});

export const { setUserInfo } = authSlice.actions;

export default authSlice.reducer;
